
import AuthService from "../services/auth.service";
import useApi from "./useApi";
import useAuth from "./useAuth";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { deactivateWebToken } from "../utils/webPushSync";

const useLogout = () => {
    const { auth, setAuth } = useAuth();
    const navigate = useNavigate();
    const api = useApi();
    const logout = async () => {
        if (auth?.accessToken) {
            try {
                await deactivateWebToken({ appName: "admin", axios: api }).catch(() => {});
                await AuthService.logout(api)
            } catch (e) { }
        }
        setAuth({});
        navigate("/login");
        localStorage.clear();
        sessionStorage.clear();
        localStorage.removeItem("accessToken");
    }
    
    return logout;
}

export default useLogout
